/*
  Create by BaiZhiming 2016-3-8。
 */
'use strict';
angular.module('util.ueditorServiceModule', ['basicUploadPicturesModule', 'videoplayerModule', 'insertVideoModule']).factory('ueditorService', [
    '$modal',
    '$stateParams',
    '$q',
    '$timeout',
    'modalDialog',
    'localStorageService',
    'trsSelectDocumentService',
    'editingCenterService',
    'processingMaterialService',
    'messagePublishService',
    'trsUploadAVNewService',
    '$state',
    '$sessionStorage',
    'md5',
    'trsFileService',
    'trsHttpService',
    function(
        $modal,
        $stateParams,
        $q,
        $timeout,
        modalDialog,
        localStorageService,
        trsSelectDocumentService,
        editingCenterService,
        processingMaterialService,
        messagePublishService,
        trsUploadAVNewService,
        $state,
        $sessionStorage,
        md5,
        trsFileService,
        trsHttpService
    ) {

        /**
         * [filterXSS 过滤XSS向量]
         *
         * @param   {[type]}  html  [html description]
         *
         * @return  {[type]}        [return description]
         */
        function filterXSS(html) {
            return html
                .replace(/<script[^>]*>[\s\S]*?<\/[^>]*script>/gi, '') // 过滤script标签
                .replace(/&#(97|106|118|115|99|114|112|116|105)/gi, '') // 过滤ASCII码变形的javascript:xxx
                .replace(/javascript\:/gi, '') // 过滤大小写变形的 javascript:xxx
                .replace(/(<[^>]*\s*)(on[\w]*\s*=\s*\"?[\w]*\"?)([^>]*>)/gi, '$1 $3'); // 过滤元素事件属性中的XSS，如 <img src="#" onerror="alert(xxx)">
        }

        /**
         * [fixVideoAndAudio 修复音频和视频标签]
         *
         * @param   {[type]}  type     [type 类型，audio-音频，video-视频]
         * @param   {[type]}  $body  [要处理的body元素]
         * @param   {[type]}  isReturnBody  [是否返回处理后的body元素]
         *
         * @return  {[type]}           [return description]
         */
        function fixVideoAndAudio(type, $body, isReturnBody) {
            let $medias = $body.find(type);
            if ($medias.length) {
                $medias.each(function() {
                    let $item = $(this);
                    let videoId = $item.attr('videoid');
                    let relationId = $item.attr('relationid');
                    let meiziId = $item.attr('meiziid');
                    let src = type === 'audio' ? './images/playVideo.jpg' : $item.attr('poster');
                    let img = document.createElement('img');
                    if (!videoId) {
                        return false;
                    }
                    $(img).attr('videoid', videoId);
                    $(img).attr('relationid', relationId);
                    $(img).attr('meiziid', meiziId);
                    $(img).attr('resourcetype', type);
                    $(img).attr('src', src);
                    if (type === 'video') {
                        $(img).attr('_src', src);
                        $(img).addClass('trsresize');
                    }
                    $(img).attr('crossorigin', 'anonymous');
                    $(img).css('max-width', '640px');
                    $(img).css('width', '400px');
                    $(img).css('height', '225px');
                    $(img).insertAfter($item);
                    $(img).wrap('<p type="app_media_wrap"></p>');
                    $item.remove();
                    $(img)
                        .parent()
                        .css('text-align', 'center');
                });
            }
            if (isReturnBody) {
                return $body;
            }
        }

        /**
         * [replaceHtmlBlank description] 替换html内容
         * @param   {[string]}  htmlContent  [htmlContent description] html正文内容
         * @return  {[type]}                 [return description]
         */
        function replaceHtmlBlank(htmlContent) {
            htmlContent = htmlContent.replace(/(<[^>]+>)([^<>]+)(<[^>]+>)/g, function($0, $1, $2, $3) {
                var innerContent = $2.replace(/ /g, '\u3000');
                return $1 + innerContent + $3;
            });
            return htmlContent;
        }

        /**
         * [cleanContent description] 清洗正文数据,用作比对
         * @param  {[type]} htmlContent [description] 正文文本
         * @return {[type]} htmlContent [description] 清洗后的正文文本
         */
        function cleanContent(htmlContent) {
            var $dom = $('<div></div>');
            $dom.html(htmlContent);
            $dom.find('img').removeAttr('oldsrc');
            $dom.find('img[videoid]').remove();
            $dom.find('img[audioid]').remove();
            $dom.find('iframe[videoid]').remove();
            $dom.find('iframe[audioid]').remove();
            return $dom.html();
        }

        /**
         * [clearOldLocalVersionData description] 清除旧版本地版本数据
         * @return {[type]} [description]
         */
        function clearOldLocalVersionData() {
            var localVersionData = localStorage['ls.ueLocalVersion'];
            if (!localVersionData) {
                return;
            }
            localVersionData = JSON.parse(localVersionData);
            for (var i in localVersionData) {
                var data = localVersionData[i];
                for (var j in data) {
                    if (j === 'ID') {
                        localStorage.removeItem('ls.ueLocalVersion');
                        return;
                    }
                }
            }
        }

        /**
         * [sourceModeSwitch description] 源码模式下转换html正文
         * @param   {[type]}  ue           [ue description] html正文
         * @param   {[type]}  contentHtml  [contentHtml description] 转换后的html正文
         * @return  {[type]}               [return description]
         */
        function sourceModeSwitch(ue, contentHtml) {
            var ueDom = UE.dom;
            if (ue.sourceMode) {
                contentHtml = filterXSS(contentHtml); // 新增xss过滤
                // 兼容源码模式下的保存正文,解决保存正文后出现多余空格的问题。
                contentHtml = contentHtml.replace(new RegExp('[\\r\\t\\n ]*</?(\\w+)\\s*(?:[^>]*)>', 'g'), function(a, b) {
                    if (b && !ueDom.dtd.$inlineWithA[b.toLowerCase()]) {
                        return a.replace(/(^[\n\r\t ]*)|([\n\r\t ]*$)/g, '');
                    }
                    return a.replace(/(^[\n\r\t]*)|([\n\r\t]*$)/g, '');
                });
                ue.orgSetContent(contentHtml);
                return ue.oldGetContent();
            } else {
                return contentHtml;
            }
        }

        /**
         * [labelMissedCount description] 标签缺失统计
         * @param  {[type]} label [description] 标签
         * @param  {[type]} str   [description] 内容
         * @return {[type]}       [description]
         */
        function labelMissedCount(label, str) {
            let startReg = new RegExp('<' + label + '(.*?)>', 'g');
            let endReg = new RegExp('</' + label + '>', 'g');
            let startLabelArr = str.match(startReg) ? str.match(startReg) : [];
            let endLabelArr = str.match(endReg) ? str.match(endReg) : [];
            return startLabelArr.length - endLabelArr.length;
        }

        /**
         * [setColor description] 设置字体颜色
         * @param   {[type]}  str    [str description]
         * @param   {[type]}  color  [color description]
         * @return  {[type]}         [return description]
         */
        function setColor(str, color) {
            str = str.replace(/\<p\>\<\/p\>/g, '');
            if (str.indexOf('<p') > -1) {
                str = str.replace(/\<p(.*?)\>/g, function(a) {
                    return '<p style="color:' + color + '">';
                });
            } else if (str == '<br/>') {
                str = '';
            } else {
                str = '<p style="color:' + color + '">' + str + '</p>';
            }
            return str;
        }

        /**
         * [isLastStartTag description] 判断最后是否为p标签
         * @param  {[type]}  str [description] 字符串
         * @return {Boolean}     [description]
         */
        function isLastStartTag(str) {
            let startArr = str.match(/\<p(.*?)\>/g) ? str.match(/\<p(.*?)\>/g) : [];
            let endArr = str.match(/\<\/p\>/g) ? str.match(/\<\/p\>/g) : [];
            if (str.lastIndexOf(startArr[startArr.length - 1]) > str.lastIndexOf(endArr[endArr.length - 1])) {
                return str.substring(0, str.lastIndexOf(startArr[startArr.length - 1]));
            }
            return str;
        }

        /**
         * [manuscriptLabelFormat description] 广电广电文稿标签数据格式化
         * @param  {[type]} content    [description] 内容
         * @param  {[type]} type       [description] 内容
         * @param  {[type]} indexStart [description] 开始位置
         * @return {[type]}            [description]
         */
        function manuscriptLabelFormat(content, type, indexStart) {
            var index, str, startStr, startP, color;
            if (type == 'lead') {
                startP = '<p class="lead_container" style="color:#58AB5C">';
                startStr = '<span class="lead_title" contenteditable="false">';
                str = '【导语】';
                color = '#58AB5C';
            } else if (type == 'main') {
                startP = '<p class="main_container" style="color:#206EFB">';
                startStr = '<span class="main_title" contenteditable="false">';
                str = '【正文】';
                color = '#206EFB';
            } else if (type == 'afterCompile') {
                startP = '<p class="afterCompile_container" style="color:#E84F89">';
                startStr = '<span class="afterCompile_title" contenteditable="false">';
                str = '【编后】';
                color = '#E84F89';
            }
            index = content.indexOf(str, angular.isDefined(indexStart) ? indexStart : 0);
            if (index > -1) {
                if (content.substring(index - startStr.length, index) != startStr) {
                    var detailStr = content.substring(
                        index + 4,
                        content.indexOf('<p class', index + 4) > -1 ? content.indexOf('<p class', index + 4) : content.length
                    );
                    var missCount = labelMissedCount('p', detailStr);
                    if (missCount > 0) {
                        for (var i = missCount; i > 0; i--) {
                            detailStr = detailStr + '</p>';
                        }
                    } else if (missCount < 0) {
                        for (var i = -missCount; i > 0; i--) {
                            detailStr = '<p>' + detailStr;
                        }
                    }
                    content =
                        isLastStartTag(content.substring(0, index)) +
                        startP +
                        startStr +
                        str +
                        '</span></p>' +
                        setColor(detailStr, color) +
                        content.substring(index + 1 + detailStr.length);
                }
                return manuscriptLabelFormat(content, type, index + startP.length + startStr.length + str.length);
            } else {
                return content;
            }
        }

        /**
         * [manuscriprSort description] 广电广电文稿格式排版
         * @param   {[type]}  content  [content description]
         * @param   {[type]}  type     [type description]
         * @param   {[type]}  color    [color description]
         * @return  {[type]}           [return description]
         */
        function manuscriprSort(content, type, color) {
            var reg,
                startStr = '';
            if (type == 'lead') {
                startStr = '<span class="lead_title" contenteditable="false">【导语】</span>';
                reg = /(\<span\sclass=\"lead_title\"\scontenteditable=\"false\"\>【导语】\<\/span\>)(.*?)(\<\/p\>?)/g;
            } else if (type == 'main') {
                startStr = '<span class="main_title" contenteditable="false">【正文】</span>';
                reg = /(\<span\sclass=\"main_title\"\scontenteditable=\"false\"\>【正文】\<\/span\>)(.*?)(\<\/p\>?)/g;
            } else if (type == 'afterCompile') {
                startStr = '<span class="afterCompile_title" contenteditable="false">【编后】</span>';
                reg = /(\<span\sclass=\"afterCompile_title\"\scontenteditable=\"false\"\>【编后】\<\/span\>)(.*?)(\<\/p\>?)/g;
            }
            content = content.replace(reg, function(str) {
                str = str.replace(/(\&nbsp\;)/g, '');
                if (startStr + '</p>' == str) {
                    return str;
                } else {
                    var startPos = startStr.length;
                    var endPos = str.indexOf('</p>');
                    var strContent = str.substring(startPos, endPos);
                    return startStr + '</p><p style="color:' + color + '">' + strContent + '</p>';
                }
            });
            return content;
        }

        /**
         * [colorFormat description] 字体颜色全部重置（防止用户手动修改颜色）
         *
         * @param   {[type]}  content  [content description] 内容
         * @param   {[type]}  type     [type description] 类型
         * @param   {[type]}  color    [color description] 颜色
         *
         * @return  {[type]}           [return description]
         */
        function colorFormat(content, type, color) {
            let reg;
            if (type === 'lead') {
                reg = /(\<p\sclass=\"lead_container\")((.*?)(\<p\sclass?)|(.*)(\<\/p\>))/g;
            } else if (type === 'main') {
                reg = /(\<p\sclass=\"main_container\")((.*?)(\<p\sclass?)|(.*)(\<\/p\>))/g;
            } else if (type === 'afterCompile') {
                reg = /(\<p\sclass=\"afterCompile_container\")((.*?)(\<p\sclass?)|(.*)(\<\/p\>))/g;
            }
            content = content.replace(reg, (str) => {
                str = str.replace(/\<p\sstyle=(.*?)\>/g, function(a) {
                    return '<p style="color:' + color + '">';
                });
                str = str.replace(/\<span\sstyle=(.*?)\>/g, function(a) {
                    return '<span style="color:' + color + '">';
                });
                return str;
            });
            return content;
        }

        return {
            insertVideo: function(success) {
                var modalInstance = $modal.open({
                    templateUrl: './components/util/ueditor/service/insertVideo/insertVideo_tpl.html?myvideoclose=' + window.location.href,
                    windowClass: 'ueditor-insertVideo-window',
                    backdrop: false,
                    controller: 'insertVideoCtrl',
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            saveContent: function(list) {
                if (!window.UE) {
                    return;
                }
                var ue = window.UE.getEditor('ueditor');
                var contentHtml = ue.getAllPageContent(),
                    hasImage = false,
                    hasIframe = false; // 插入外部视频
                contentHtml = this.clearMarkHeimaWord(contentHtml);
                messagePublishService.publish('clearMarkHeimaWord');
                contentHtml = sourceModeSwitch(ue, contentHtml); // 自动检测转换html模式下的正文
                contentHtml = contentHtml.replace(/trasScale red/g, ''); // 保存的时候将敏感词标记去掉
                contentHtml = contentHtml.replace(/<p><\/p>/gi, '');
                contentHtml = contentHtml.replace(/=\"\\\"/gi, '=""');
                // contentHtml = contentHtml.replace(/(background|background\-image)\s*\:\s*url\s*\(\s*(('|"|&quot;)?)\s*(data:image\/[^\)]*)\2\s*\)/gi, 'background: url()');
                contentHtml = contentHtml.replace(/\(&quot;/gi, '(');
                contentHtml = contentHtml.replace(/&quot;\)/gi, ')');
                if ($state.current.name === 'newspapertext') {
                    contentHtml = contentHtml.replace('∙', '·');
                    contentHtml = contentHtml.replace('•', '·');
                    contentHtml = contentHtml.replace('・', '·');
                    contentHtml = contentHtml.replace('&zwnj;', '');
                }
                if ($state.current.name === 'newspapertext') {
                    contentHtml = contentHtml.replace(/∙/g, '·');
                    contentHtml = contentHtml.replace(/•/g, '·');
                    contentHtml = contentHtml.replace(/・/g, '·');
                    contentHtml = contentHtml.replace(/\u200c/g, '');
                }
                var contentTxt = (function() {
                    var dom = document.createElement('div');
                    dom.innerHTML = contentHtml;
                    hasImage = $(dom).find('img').length > 0;
                    hasIframe = $(dom).find('iframe').length > 0;
                    return dom.innerText;
                })();
                if (
                    contentTxt
                        .replace(/\u3000/g, '')
                        .replace(/\u0020/g, '')
                        .replace(/\u200b/g, '') // 过滤掉领宽度空白
                        .replace(/\n/g, '') === '' &&
                    !hasImage &&
                    !hasIframe
                ) {
                    list.HTMLCONTENT = '';
                    list.CONTENT = '';
                    list.DOCWORDSCOUNT = 0;
                } else {
                    list.HTMLCONTENT = contentHtml;
                    list.HTMLCONTENT = list.HTMLCONTENT.replace(
                        /<hr ispageseparator=\"true\"\/>/g,
                        '<trs_page_separator pagetitle="" firstpagetitle=""></trs_page_separator>'
                    ); // 替换分页符置标
                    // 保存的时候 content里面去掉图说标签
                    var modifyContent = document.createElement('div');
                    modifyContent.innerHTML = list.HTMLCONTENT;
                    $(modifyContent)
                        .find('p[class="imagenote"]')
                        .remove();
                    // var modifyContent = list.HTMLCONTENT.replace(<(p|P)[^>]*type=(\"|')imagenote(\"|')(.*?)>(.*?),</(p|P)>, '<p></p>')
                    list.CONTENT = this.getTextContent(modifyContent.innerHTML); // 解决纯文本带图说问题
                    list.CONTENT = list.CONTENT.replace(/<[^>]+>/g, '').replace(/\u200b/g, ''); // 解决纯文本带标签问题 ,并过滤掉零宽度空白
                    list.DOCWORDSCOUNT = this.getTextContent(ue.getContentTxt())
                        .replace(/\n/g, '')
                        .replace(/\n/g, '') // 解决字数问题 因为content经过了处理 还是使用编辑器返回的纯文本算字数（图说的字数还需要讨论）
                        .replace(/\u0020/g, '')
                        .replace(/\u200b/g, '') // 计算长度时要过滤掉领宽度空白
                        .replace(/\u3000/g, '').length;
                }
            },

            /**
             * [clearMarkHeimaWord description] 清除黑马标志
             * @param {string} [htmlContent] [description] 正文
             * @return {[type]} [description]
             */
            clearMarkHeimaWord: function(htmlContent) {
                var dom = document.createElement('div');
                dom.innerHTML = htmlContent;
                $(dom)
                    .find('span.trasScale')
                    .each(function() {
                        $(this).replaceWith(this.innerHTML.replace(/\（.*\）/, ''));
                    });
                return dom.innerHTML;
            },

            /* *
             * [getTextContent description] 获取纯文本正文
             * @param  {[String]} htmlContent [description] html正文
             * @param  {[Boolean]} filterHtml [description] 是否需要过滤html
             * @return {[String]} content        [description] 纯文本正文
             */
            getTextContent(htmlContent, filterHtml) {
                var content = htmlContent.replace(/\n/g, '');
                content = content.replace(/>[^<]*</gi, function($1) {
                    $1 = $1.replace(/\u00a0/g, ' ').replace(/\u0020/g, ' ');
                    return $1;
                });
                content = content
                    .replace(/<\/p>/g, '\n')
                    .replace(/<\/div>/g, '\n')
                    .replace(/<(p|div)[^>]*>/gi, '')
                    .replace(/<br\/?>/gi, '\n')
                    // .replace(/<[^>]+>/g, '')
                    .replace(/(&nbsp;){4}/g, '\u3000');
                if (filterHtml) {
                    content = content.replace(/<[^>]+>/g, '');
                }
                if (content[content.length - 1] === '\n') {
                    //  去掉文章末尾的换行
                    content = content.substring(0, content.length - 1);
                }
                content = content.replace(/\u00a0/g, ' ');
                return content;
            },

            /* *
             * [bindContentForKeyword description] 提取关键词跟摘要使用换行的正文
             * @return {[type]} [description]
             */
            bindContentForKeyword: function() {
                var ue = UE.getEditor('ueditor');
                var HTMLCONTENT = ue.getContent();
                HTMLCONTENT = sourceModeSwitch(ue, HTMLCONTENT); // 自动检测转换html模式下的正文
                var dom = document.createElement('div');
                dom.innerHTML = HTMLCONTENT;
                var htmlContent = dom.innerHTML
                    .replace(/<\/p>/g, '\n')
                    .replace(/<\/div>/g, '\n')
                    .replace(/<(p|div)[^>]*>/gi, '')
                    .replace(/<br\/?>/gi, '\n')
                    .replace(/<[^>]+>/g, '')
                    .replace(/(&nbsp;){4}/g, '\u3000');
                if (htmlContent[htmlContent.length - 1] === '\n') {
                    //  去掉文章末尾的换行
                    htmlContent = htmlContent.substring(0, htmlContent.length - 1);
                }
                var content = htmlContent.replace(/\u00a0/g, ' ').replace(/<!--((.*)|(\n))*?-->/g, '');
                return content;
            },
            bindContent: function() {
                var ue = UE.getEditor('ueditor');
                var HTMLCONTENT = ue.getContent();
                HTMLCONTENT = sourceModeSwitch(ue, HTMLCONTENT); // 自动检测转换html模式下的正文
                var content = HTMLCONTENT.replace(/\n/g, '');
                var dom = document.createElement('div');
                dom.innerHTML = content;
                content = dom.innerText.replace(/\u00a0/g, ' ').replace(/<!--((.*)|(\n))*?-->/g, '');
                return content;
            },
            contentTranscoding: function(list) {
                var htmlcontent = list.HTMLCONTENT;
                var content = htmlcontent.replace(/\n/g, '');
                var dom = document.createElement('div');
                dom.innerHTML = content;
                content = dom.innerText.replace(/\u00a0/g, ' ').replace(/<!--((.*)|(\n))*?-->/g, '');
                return content;
            },

            /* *
             * [sourceModeSwitch description]源码模式下转换html正文
             * @param {string} [htmlcontent] [description] html正文
             * @return {string} htmlcontent  [description] 转换后的html正文
             */
            sourceModeSwitch: function(ue, contentHtml) {
                return sourceModeSwitch(ue, contentHtml);
            },
            replaceHtmlBlank: function(htmlContent, versionid) {
                return replaceHtmlBlank(htmlContent);
            },

            /**
             * [hasLocalVersion 是否有本地缓存的版本]
             *
             * @param   {[type]}  docId  [docId 稿件ID]
             * @param   {[type]}  way    [way 渠道标识]
             *
             * @return  {[type]}         [return description]
             */
            hasLocalVersion: function(docId, way) {
                way = way === undefined ? 'iwo' : way;
                way = way === 'newsPaper_Fusion' ? 'newsPaper' : way;
                let hasLocalVersion = false;
                var localContentArray = localStorageService.get('ueLocalVersion');
                if (!localContentArray) {
                    return hasLocalVersion;
                }
                for (var i = 0; i < localContentArray.length; i++) {
                    if (localContentArray[i][way + '_ID'] == docId) {
                        hasLocalVersion = true;
                    }
                }
                return hasLocalVersion;
            },

            /**
             * [deleteLocalVersion 删除本地缓存的版本]
             *
             * @param   {[type]}  docId  [docId 稿件ID]
             * @param   {[type]}  way    [way 渠道标识]
             *
             * @return  {[type]}         [return description]
             */
            deleteLocalVersion: function(docId, way) {
                way = way === undefined ? 'iwo' : way;
                way = way === 'newsPaper_Fusion' ? 'newsPaper' : way;
                var localContentArray = localStorageService.get('ueLocalVersion');
                if (!localContentArray) {
                    return;
                }
                for (var i = 0; i < localContentArray.length; i++) {
                    if (localContentArray[i][way + '_ID'] == docId) {
                        localContentArray.splice(i, 1);
                    }
                }
                localStorageService.set('ueLocalVersion', localContentArray);
            },

            saveToLocal: function(docId, way, content, versionid) {
                way = way === undefined ? 'iwo' : way;
                way = way === 'newsPaper_Fusion' ? 'newsPaper' : way;
                var version;
                clearOldLocalVersionData();
                versionid = angular.isDefined(versionid) && versionid !== '' ? versionid : '0';
                if (content !== '') {
                    var storage = localStorageService.get('ueLocalVersion');
                    if (storage !== null) {
                        var flag = true;
                        for (var i = 0; i < storage.length; i++) {
                            if (storage[i][way + '_ID'] === docId + '') {
                                storage[i].CONTENT = content;
                                storage[i].VERSIONID = versionid;
                                flag = false;
                                break;
                            }
                        }
                        if (flag) {
                            version = {
                                CONTENT: content,
                                VERSIONID: versionid,
                            };
                            version[way + '_ID'] = docId + '';
                            storage.unshift(version);
                            if (storage.length > 40) {
                                storage.length = 40;
                            }
                        }
                        localStorageService.set('ueLocalVersion', storage);
                    } else {
                        var ueLocalVersion = [];
                        version = {
                            CONTENT: content,
                            VERSIONID: versionid,
                        };
                        version[way + '_ID'] = docId + '';
                        ueLocalVersion.push(version);
                        localStorageService.set('ueLocalVersion', ueLocalVersion);
                    }
                }
            },

            /* *
             * [compareLocalAndServe description]
             *
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  way    [way description]
             * @param   {[type]}  isClose    [way 是否是关闭时的对比]
             *
             * @return  {[type]}         [return description]
             */
            compareLocalAndServe: function(scope, way, isClose) {
                var self = this;
                way = way === undefined ? 'iwo' : way;
                way = way === 'newsPaper_Fusion' ? 'newsPaper' : way;
                var ue = UE.getEditor('ueditor');
                scope.versionid = scope.versionid === '' ? '0' : scope.versionid;
                var deffer = $q.defer();
                var htmlContent = cleanContent(scope.list.HTMLCONTENT);
                var localContentArray = localStorageService.get('ueLocalVersion');
                var localContent;
                if (localContentArray === null) {
                    deffer.resolve();
                } else if ($stateParams.issave && $stateParams.issave == '1') {
                    //  融合编辑器，保存时不提示是否恢复本地版本
                    deffer.resolve();
                } else {
                    for (var i = 0; i < localContentArray.length; i++) {
                        if (
                            localContentArray[i][way + '_ID'] === scope.list.METADATAID + '' &&
                            (angular.isUndefined(scope.versionid) ||
                                angular.isUndefined(localContentArray[i].VERSIONID) ||
                                localContentArray[i].VERSIONID === scope.versionid)
                        ) {
                            localContent = cleanContent(localContentArray[i].CONTENT);
                        }
                    }
                    if (angular.isUndefined(localContent)) {
                        deffer.resolve();
                    } else if (htmlContent === localContent) {
                        deffer.resolve();
                    } else if (htmlContent !== localContent) {
                        if ($stateParams.issave) {
                            //  融合编辑器时不作任何提示
                            deffer.resolve();
                            return deffer.promise;
                        }
                        if (!isClose) {
                            self.shouldRecoverLocalVersion(
                                scope,
                                function() {
                                    ue.setContent(localContent);
                                    deffer.resolve();
                                },
                                function() {
                                    self.deleteLocalVersion(scope.list.METADATAID, way);
                                    deffer.resolve();
                                }
                            );
                        } else {
                            self.shouldCloseWithoutSave(
                                function() {
                                    deffer.resolve(true);
                                },
                                function() {
                                    deffer.resolve(false);
                                }
                            );
                        }
                    }
                }
                return deffer.promise;
            },

            shouldCloseWithoutSave: function(confirmFn, cancelFn) {
                let tipInfo = '您还未保存已填写的内容';
                modalDialog.alertTypeWithCloseBtn(tipInfo, '', 'warning', true, confirmFn, cancelFn, '10000', '放弃保存', '保存关闭');
            },

            /**
             * [shouldRecoverLocalVersion 是否恢复到本地版本]
             *
             * @param   {[type]}  scope     [ue description]
             * @param   {[type]}  confirmFn  [scope description]
             * @param   {[type]}  cancelFn  [scope description]
             *
             * @return  {[type]}         [return description]
             */
            shouldRecoverLocalVersion: function(scope, confirmFn, cancelFn) {
                let tipInfo =
                    scope.list.METADATAID === 0
                        ? '确定恢复未保存的稿件正文至编辑区？'
                        : '检测到服务器稿件正文与本地稿件正文有差异，是否恢复本地版本正文？';
                modalDialog.alertType(
                    tipInfo,
                    '',
                    'info',
                    true,
                    function() {
                        confirmFn();
                    },
                    function() {
                        cancelFn();
                    }
                );
            },

            /* *
             * [deleteLocalTempVersion description] 清除本地临时版本、即metadataid为0的本地版本
             * @return {[type]} [description]
             */
            deleteLocalTempVersion: function(way) {
                var localContentArray = localStorageService.get('ueLocalVersion');
                if (!localContentArray) {
                    return;
                }
                for (var i = 0; i < localContentArray.length; i++) {
                    if (localContentArray[i][way + '_ID'] == '0') {
                        // newContent = localContentArray[i].CONTENT;
                        localContentArray.splice(i, 1);
                        break;
                    }
                }
                localStorageService.set('ueLocalVersion', localContentArray);
            },

            /* *
             * 监控metedataid变化，并更新到本地版本
             */
            watchMetadataidAndUpdateLocalVersion: function(scope, way) {
                var self = this;
                way = way === undefined ? 'iwo' : way;
                way = way === 'newsPaper_Fusion' ? 'newsPaper' : way;
                scope.$watch('list.METADATAID', function(newValue, oldValue) {
                    // 新建稿件时，将ID为0的本地版本内容迁到新生成的ID的稿件正文中
                    var newId = newValue + '';
                    var oldId = oldValue + '';
                    if (newId !== oldId && oldId == '0') {
                        self.deleteLocalTempVersion(way);
                    }
                });
            },

            /* *
             * [asaveVersionIntervaltime description]编辑器保存本地版本间隔时间
             * @param  {[type]} chl [description]
             * @return {[type]}     [description]
             */
            asaveVersionIntervaltime: function() {
                return 60000; // 两分钟
            },

            /* *
             * [handlingSensitiveInf description]处理敏感信息
             * @param  {[type]} SensitiveWordresults [description]敏感词结果
             * @param  {[type]} htmlcontent [description]html正文
             * @return {[type]}      [description]
             */
            handlingSensitiveInf: function(SensitiveWordresults, htmlcontent) {
                var resultInfo = SensitiveWordresults.content[0].resultInfo;
                for (var i = 0; i < resultInfo.length; i++) {
                    htmlcontent = htmlcontent.replace(
                        new RegExp(resultInfo[i].errorWord, 'g'),
                        "<span style='background-color:#F89F9F' title='" + resultInfo[i].errorInfo + "'>" + resultInfo[i].errorWord + '</span>'
                    );
                }
                return htmlcontent;
            },

            /* *
             * [removeToolBarFunction description]剔除编辑器工具栏按键的功能
             * @param  {[type]}  toolBar [description] 工具条对象
             * @param  {[array]} indexArray [description]功能键序号
             * @return {[type]}      [description]
             */
            removeToolBarFunction: function(toolBar, indexArray) {
                indexArray.sort(function(a, b) {
                    return b - a;
                });
                for (var i = 0; i < indexArray.length; i++) {
                    var index = indexArray[i];
                    toolBar.splice(index, 1);
                }
                return toolBar;
            },

            /**
             * [basicUploadPic description] 上传图片统一行为
             */
            basicUploadPic: function() {
                var deffer = $q.defer();
                let options = {
                    resourceType: '0',
                    isMulti: true,
                };
                editingCenterService.mediaSelector(options).then(function(result) {
                    // var newHtml = processingMaterialService.editPicture(result.list);
                    deffer.resolve(result.list);
                });
                return deffer.promise;
            },

            basicUploadAudio: function(UE, ue) {
                var deffer = $q.defer();
                let options = {
                    resourceType: '1', // 音频
                    isMulti: true,
                };
                trsUploadAVNewService
                    // .openVideoModal(scope.list.METADATAID, scope.type, scope.list.CHNLDOCID, true, true)
                    .opennewAudioModal()
                    .then(function(data) {
                        for (var i = 0; i < data.html.length; i++) {
                            if (data.html[i].videoHtml) {
                                var dom = document.createElement('div');
                                dom.innerHTML = data.html[i].videoHtml;
                                ue = ue ? ue : UE.getEditor('ueditor');
                                ue.execCommand('inserthtml', dom.innerHTML);
                                ue.focus();
                                setTimeout(function() {
                                    ue.fireEvent('contentChange');
                                }, 800);
                            }
                        }
                    });
                return deffer.promise;
            },

            /**
             * [insertImages description] 插入图片统一行为
             */
            insertImages: function(data) {
                var defer = $q.defer();
                var newHtml = processingMaterialService.editPicture(data);
                var dom = document.createElement('div');
                dom.innerHTML = newHtml;
                var index = 0;
                var $imgs = $(dom).find('img');
                var targetWidth = window.UE.getEditor('ueditor').options.initialFrameWidth - 40; // 目标宽度
                $imgs.each(function() {
                    this.onload = function() {
                        if (this.width > targetWidth) {
                            // 图片大于当前编辑器最大宽度时候处理 少40px是为了对称
                            $(this).attr('width', targetWidth);
                        }
                        index++;
                        if (index === $imgs.length) {
                            defer.resolve(dom.innerHTML);
                        }
                    };
                });
                return defer.promise;
            },

            /* *
             * [getToolBar description]获取编辑器的工具条
             * @return {[obj]}   toolBar   [description]
             */
            getToolBar: function() {
                return {
                    toolbars: [
                        // [
                        //     //'source' /*0*/,
                        //     'undo' /*1*/,
                        //     'redo' /*2*/,
                        //     '|' /*3*/,
                        //     'cut' /*4*/,
                        //     'copy' /*5*/,
                        //     'paste' /*6*/,
                        //     '|' /*7*/,
                        //     'customstyle' /*8*/,
                        //     'fontfamily' /*9*/,
                        //     'fontsize' /*10*/,
                        //     'forecolor' /*11*/,
                        //     'bold' /*12*/,
                        //     'italic' /*13*/,
                        //     'underline' /*14*/,
                        //     'strikethrough' /*15*/,
                        //     'subscript' /*16*/,
                        //     'backcolor' /*17*/,
                        //     '|' /*18*/,
                        //     'justifyleft' /*19*/,
                        //     'justifycenter' /*20*/,
                        //     'justifyright' /*21*/,
                        //     'justifyjustify' /*22*/,
                        //     '|' /*23*/,
                        //     'insertorderedlist' /*24*/,
                        //     'insertunorderedlist' /*25*/,
                        //     'directionalityltr' /*26*/,
                        //     'directionalityrtl' /*27*/,
                        //     'lineheight' /*28*/,
                        //     /* 'background', 'backgroundimg', */
                        //     '|' /*29*/,
                        //     'formatmatch' /*30*/,
                        //     'searchreplace' /*31*/,
                        //     'insertframe' /*32*/,
                        //     'insertimage' /*'insertvideo' ,*/ /*33*/,
                        //     'link' /*34*/,
                        //     'unlink' /*35*/,
                        //     'inserttable' /*36*/,
                        //     'insertrow' /*37*/,
                        //     'insertcol' /*38*/,
                        //     'inserttitle' /*39*/,
                        //     'insertparagraphbeforetable' /*40*/,
                        //     'fullscreen' /*41*/,
                        //     'removeformat' /*42*/,
                        //     'autotypeset' /*43*/,
                        //     'indent' /*44*/,
                        //     'pasteplain' /*45*/,
                        //     '135editor' /*46*/,
                        //     'xiumi' /*47*/,
                        // ],
                        [
                            'source' /* 0*/,
                            'undo' /* 1*/,
                            'redo' /* 2*/,
                            'fontsize' /* 3*/,
                            'fontfamily' /* 4*/,
                            'customstyle' /* 5*/,
                            // 引用？/*6*/

                            '|' /* 7*/, // 文字进行调整
                            'removeformat' /* 8*/,
                            'formatmatch' /* 9*/,
                            'bold' /* 10*/,
                            'italic' /* 11*/,
                            'underline' /* 12*/,
                            'forecolor' /* 13*/,
                            'backcolor' /* 14*/,
                            'strikethrough' /* 15*/,
                            // 文字间距 /*16*/

                            '|' /* 17*/, // 文字段落调整
                            'lineheight' /* 18*/,
                            'indent' /* 19*/,
                            'justifyleft' /* 20*/,
                            'justifycenter' /* 21*/,
                            'justifyright' /* 22*/,
                            'justifyjustify' /* 23*/,
                            // 两端缩进？/*24*/
                            // 段前距  /*25*/
                            // 段后距  /*26*/
                            'insertorderedlist' /* 27*/,
                            'insertunorderedlist' /* 28*/,

                            '|' /* 29*/, // 插入
                            'link' /* 30*/,
                            'unlink' /* 31*/,

                            'inserttable' /* 32*/,
                            'insertrow' /* 33*/,
                            'insertcol' /* 34*/,
                            'inserttitle' /* 35*/,
                            'insertparagraphbeforetable' /* 36*/,
                            'searchreplace' /* 37*/,

                            '|' /* 38*/, // 其他
                            // 'insertimage' /*39*/,
                            // 'insertvideo' /*40*/,
                            // 恢复本地版本  /*41*/,
                            'fullscreen' /* 42*/,
                            'pagenum',
                            'key4format',
                        ],
                    ],
                    labelMap: {
                        anchor: '',
                        undo: '',
                        cut: '剪切',
                        copy: '复制',
                        paste: '粘贴',
                        backgroundimg: '背景图',
                        allowCopyImg: true, //  自定义百度编辑器配置项，禁止拷贝图片到编辑器
                    },
                    //  如果自定义，最好给p标签如下的行高，要不输入中文时，会有跳动感
                    //  initialStyle: 'p{line-height:1.5em}', // 编辑器层级的基数,可以用来改变字体等 为了适配复制微信公众号的文章先将这个注释
                    maximumWords: 100000,
                    autoHeightEnabled: true,
                    topOffset: 60,
                    enableContextMenu: false,
                    allowDivTransToP: true,
                    imageScaleEnabled: true,
                    pasteplain: false,
                    // fontsize: [10, 11, 12, 14, 16, 17, 18, 20, 24, 36],
                    fontsize: [56, 48, 35, 32, 29, 24, 21, 20, 19, 16, 14, 12, 12, 14, 16, 18, 20, 24, 36, 48, 72],
                    fontsizename: [
                        '初号',
                        '小初',
                        '一号',
                        '小一',
                        '二号',
                        '小二',
                        '三号',
                        '小三',
                        '四号',
                        '小四',
                        '五号',
                        '小五',
                        '12px',
                        '14px',
                        '16px',
                        '18px',
                        '20px',
                        '24px',
                        '36px',
                        '48px',
                        '72px',
                    ],
                    // pageBreakTag:'\<trs_page_separator pagetitle=\"\" firstpagetitle=\"\"\>\<\/trs_page_separator\>'
                };
            },

            /* *
             * [ueReady description]等待编辑器加载完成
             * @param   {[type]}  success       [success description] 加载完成后的回调函数
             * @param   {[type]}  hasNoUeditor  [hasNoUeditor description]
             *
             * @return  {[type]}                [return description]
             */
            ueReady: function(success, hasNoUeditor) {
                if (hasNoUeditor) {
                    success();
                } else {
                    var self = this;
                    if (!!window.UE && angular.isFunction(window.UE.getEditor)) {
                        var ue = window.UE.getEditor('ueditor');
                        ue.ready(function() {
                            $timeout(function() {
                                success();
                            });
                        });
                    } else {
                        $timeout(function() {
                            self.ueReady(success);
                        }, 500);
                    }
                }
            },

            /**
             * [videoPlayer description] 编辑器内的音视频播放器
             * @param   {[string]}  videoid  [videoid description] 视频唯一标识
             * @param   {[string]}  type     [type description] 音视频类型
             * @return  {[type]}             [return description]
             */
            videoPlayer: function(videoid, type, relationid, meiziid) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './components/util/ueditor/service/videoplayer/videoplayer_tpl.html',
                    windowClass: 'ueditor-video-window',
                    backdrop: false,
                    controller: 'videoplayerCtrl',
                    resolve: {
                        item: function() {
                            return {
                                videoid: videoid,
                                type: type,
                                relationid: relationid,
                                meiziid: meiziid,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    deffer.resolve(result);
                });
                return deffer.promise;
            },

            /* *
             * [rewriteFullScreen description] 重写全屏方法
             * @param  {[type]} UE [description]
             * @param {int} [top] [description] 顶部修正距离
             * @return {[type]}    [description]
             */
            rewriteFullScreen: function(UE, top) {
                var isInFullScreen = false;
                var ue = UE.getEditor('ueditor');
                ue.ready(function() {
                    var $body = $('body');
                    var $container = $(ue.container);
                    var $ueBody = $(ue.body);
                    var $toolBar = $container.find('.edui-editor-toolbarboxouter');
                    var toolBarParentStyle;
                    var resizeEvent;
                    if (ue.ui) {
                        ue.ui.setFullScreen = function() {
                            if (!isInFullScreen) {
                                toolBarParentStyle = $toolBar.parent().attr('style');
                                $container.addClass('full-screen');
                                $container.css({ top: top, height: window.innerHeight - top });
                                isInFullScreen = true;
                                $container.unbind('scroll', myScroll).bind('scroll', myScroll);
                                $body.css('overflow', 'hidden');
                                $toolBar.parent().removeAttr('style');
                                $toolBar
                                    .parent()
                                    .prev()
                                    .remove();
                                myScroll({ target: $container[0] });
                                linstenerWindowResize();
                            } else {
                                $container.removeClass('full-screen');
                                $container.css({ top: 'initial', height: 'initial' });
                                $toolBar.css({ top: 'initial', position: 'relative', 'zIndex': 'initial' });
                                isInFullScreen = false;
                                $container.unbind('scroll', myScroll);
                                $body.css('overflow', 'auto');
                                $toolBar.parent().attr('style', toolBarParentStyle);
                                window.removeEventListener('resize', resizeEvent);
                            }
                        };
                    }

                    /**
                     * [myScroll description] 滚动事件
                     * @param   {[type]}  e  [e description]
                     * @return  {[type]}     [return description]
                     */
                    function myScroll(e) {
                        var $target = $(e.target);
                        var scrollTop = $target.scrollTop();
                        if (scrollTop > 10) {
                            $toolBar.css({ top: top, position: 'fixed', 'zIndex': 999999, width: '100%' });
                        } else {
                            $toolBar.css({ top: 'initial', position: 'relative', 'zIndex': 'initial' });
                        }
                    }

                    /**
                     * [linstenerWindowResize description] 监控窗口的重置事件
                     * @return  {[type]}  [return description]
                     */
                    function linstenerWindowResize() {
                        window.addEventListener('resize', resizeEvent);
                    }

                    /**
                     * [resizeEvent description]
                     * @return  {[type]}  [return description]
                     */
                    function resizeEvent() {
                        $container.css({ top: top, height: window.innerHeight - top });
                    }
                });
            },

            /* *
             * [destroyCommonUe description] 销毁非135编辑器
             * @return {[type]} [description]
             */
            destroyCommonUe: function(ue) {
                ue.destroy();
                $('link').each(function() {
                    // 清除相关css防止互相污染
                    if (
                        typeof $(this).attr('href') === 'string' &&
                        $(this)
                            .attr('href')
                            .indexOf('ueditor') >= 0
                    ) {
                        $(this).remove();
                    }
                });
                $('style').each(function() {
                    if (
                        typeof $(this).attr('id') === 'string' &&
                        $(this)
                            .attr('id')
                            .indexOf('edui') >= 0
                    ) {
                        $(this).remove();
                    }
                });
                $('.edui-popup').remove();
                $('.edui-shortcutmenu').remove();
                delete window.UE;
            },

            /* *
             * [get135Editor description] 获取135编辑器
             * @return {[type]} [description]
             */
            get135Editor: function() {
                var deffer = $q.defer();
                $('.myLazyLoad').remove();
                getCss()
                    .then(function() {
                        return getJS();
                    })
                    .then(function() {
                        deffer.resolve();
                    });

                /**
                 * [getJS description] 获取依赖的js
                 * @return  {[type]}  [return description]
                 */
                function getJS() {
                    var deffer_ = $q.defer();
                    var urls = [
                        './lib/135editor/ueditor.config.js?v=1.1',
                        './lib/135editor/ueditor.all.min.js?v=1.1',
                        './lib/135editor/lang/zh-cn/zh-cn.js?v=1.1',
                        './lib/135editor/a92d301d77.js',
                    ];
                    var scripts = [];
                    for (var i = 0; i < urls.length; i++) {
                        var $script = $('<script></script>').attr({ src: urls[i], class: 'myLazyLoad' });
                        // $script[0].onload = function () {
                        // };
                        scripts.push($script);
                    }
                    $('head').append(scripts);
                    $timeout(function() {
                        deffer_.resolve();
                    }, 100);
                    return deffer_.promise;
                }

                /**
                 * [getCss description]
                 * @return  {[type]}  [return description]
                 */
                function getCss() {
                    var deffer__ = $q.defer();
                    var $link = $("<link rel='stylesheet' class='myLazyLoad' href='./lib/135editor/96619a5672.css'></link>");
                    $('head').append($link);
                    $timeout(function() {
                        deffer__.resolve();
                    }, 100);
                    return deffer__.promise;
                }
                return deffer.promise;
            },

            /* *
             * [cloudPlate description] 云平台组件
             * @param  {[type]}    [description]
             * @return {[type]}    [description]
             */
            cloudPlate: function() {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './components/util/ueditor/service/template/cloudPlate_tpl.html',
                    windowClass: 'cloud-plate-window',
                    backdrop: false,
                    controller: 'cloudPlateCtrl',
                });
                modalInstance.result.then(function(result) {
                    deffer.resolve(result);
                });
                return deffer.promise;
            },

            /* *
             * [insertInternalLink description] 插入内链
             * @return {[type]} [description]
             */
            insertInternalLink: function() {
                var deffer = $q.defer();
                trsSelectDocumentService.trsSelectDocumentInternalLink().then(function(result) {
                    deffer.resolve(result);
                });
                return deffer.promise;
            },

            /* *
             * [insertInternalLink description] 批量水印
             * @return {[type]} [description]
             */
            multiImgsWaterLink: function(sendList) {
                var deffer = $q.defer();
                editingCenterService.multiImgsWatermark(sendList, $stateParams.wzsiteid || $stateParams.appsiteid).then((response) => {
                    deffer.resolve(response);
                });
                return deffer.promise;
            },

            /* *
             * [typesettingManuscript description] 电视广电文稿排版
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            typesettingManuscript: function(content) {
                let leadFormat = manuscriptLabelFormat(content, 'lead');
                let mainFormat = manuscriptLabelFormat(leadFormat, 'main');
                let afterCompileFormat = manuscriptLabelFormat(mainFormat, 'afterCompile');
                let leadContent = manuscriprSort(afterCompileFormat, 'lead', '#58AB5C');
                let mainContent = manuscriprSort(leadContent, 'main', '#206EFB');
                let afterCompileContent = manuscriprSort(mainContent, 'afterCompile', '#E84F89');
                let leadColorContent = colorFormat(afterCompileContent, 'lead', '#58AB5C');
                let mainColorContent = colorFormat(leadColorContent, 'main', '#206EFB');
                let afterCompileColorContent = colorFormat(mainColorContent, 'afterCompile', '#E84F89');
                return afterCompileColorContent;
            },
            initializeManuscript: function() {
                var htmlTemplate = [
                    {
                        color: '#58AB5C',
                        content:
                            '<p class="lead_container" style="color:#58AB5C"><span class="lead_title" contenteditable="false">【导语】</span></p><p><br/></p>',
                        name: '导语',
                    },
                    {
                        color: '#206EFB',
                        content:
                            '<p class="main_container" style="color:#206EFB"><span class="main_title" contenteditable="false">【正文】</span></p><p><br/></p>',
                        name: '正文',
                    },
                    {
                        color: '#E84F89',
                        content:
                            '<p class="afterCompile_container" style="color:#E84F89"><span class="afterCompile_title" contenteditable="false">【编后】</span></p><p><br/></p>',
                        name: '编后',
                    },
                ];
                return htmlTemplate;
            },
            autotypesetFun: function(ue, media) {
                // 获取一键排版的默认配置，如果之前有操作，获取cookie中记录值
                var cookieOpt = ue.getPreferences('autotypeset', media);
                var opt = cookieOpt ? cookieOpt : ue.options.autotypeset;
                if (!cookieOpt) {
                    opt.pasteFilter = true;
                    opt.removeEmptyNode = true;
                    if (media === 'app') {
                        opt.textAlign = 'justify';
                        opt.lineheight = {
                            flag: true,
                            val: '1.5',
                        };
                    }
                }
                var modalInstance = $modal.open({
                    templateUrl: './components/util/ueditor/service/autotypeSet/autotypeset_tpl.html',
                    windowClass: 'autotypeset',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        setparams: function() {
                            return {
                                opt: opt,
                                editor: ue,
                                media: media,
                            };
                        },
                    },
                    controller: 'autotypesetCtrl',
                });
                modalInstance.result.then(function(result) {
                    ue.setPreferences('autotypeset', result, media);
                    $('#authorization_box').show(); // 正在排版Loading
                    setTimeout(function() {
                        $('#authorization_box').hide(); // 定时隐藏正在排版Loading
                    }, 2000);
                    $(ue.body).addClass('TRS_UEDITOR');
                    // 为一键排版样式设置值
                    ue.options.autotypeset = result;
                    ue.execCommand('autotypeset');
                    ue.fireEvent('contentchange');
                    ue.fireEvent('selectionchange');
                });
            },

            savePasteState: function(way) {
                if (window.UE) {
                    var ue = window.UE.getEditor('ueditor');
                    let pasteState = ue.queryCommandState('pasteplain');
                    let currUserInfo = $sessionStorage.get('curUserInfo');
                    let userId = currUserInfo ? currUserInfo.ID : '-1';
                    let ueditorPasteState = localStorageService.get('ueditor.pasteState');
                    if (!ueditorPasteState) {
                        ueditorPasteState = {};
                    }
                    if (!ueditorPasteState[userId]) {
                        ueditorPasteState[userId] = {};
                    }
                    ueditorPasteState[userId][way] = pasteState === 1;
                    localStorageService.set('ueditor.pasteState', ueditorPasteState);
                }
            },

            fixAppHtmlTag: function(htmlContent) {
                let html;
                let body = document.createElement('div');
                $(body).html(htmlContent);
                let $body = fixVideoAndAudio('video', $(body), true);
                $body = fixVideoAndAudio('audio', $body, true);
                html = $body.html();
                return html;
            },

            /**
             * 统一获取字数方法
             * @param ue 编辑器实例
             * @returns {*}
             */
            getDOCWORDSCOUNT: function(ue) {
                var preContent = this.getTextContent(ue.getContentTxt());
                return preContent
                    .replace(/\n/g, '')
                    .replace(/\u0020/g, '')
                    .replace(/\u3000/g, '') // 兼容大数据取稿字数算法不同问题
                    .replace(/图片自动下载失败，请手动上传/g, '') // 排除图片下载错误信息
                    .replace(/请输入图片描述/g, '').length; // 排除图说里面的placeholder内容
            },

            rewriteAutotypesetCache: function(UE) {
                var ROOTKEY = 'ueditor_preference';
                UE.Editor.prototype.setPreferences = function(key, value, media) {
                    var obj = {};
                    if (!media) {
                        media = 'default';
                    }
                    obj[media] = {};
                    if (UE.utils.isString(key)) {
                        obj[media][key] = value;
                    } else {
                        obj[media] = key;
                    }
                    var data = localStorageService.get(ROOTKEY);
                    if (data) {
                        UE.utils.extend(data, obj);
                    } else {
                        data = obj;
                    }
                    data && localStorageService.set(ROOTKEY, data);
                };

                UE.Editor.prototype.getPreferences = function(key, media) {
                    var data = localStorageService.get(ROOTKEY);
                    if (data && data[media]) {
                        return key ? data[media][key] : data;
                    }
                    return null;
                };

                UE.Editor.prototype.removePreferences = function(key, media) {
                    var data = localStorageService.get(ROOTKEY);
                    if (data && data[media]) {
                        data[media][key] = undefined;
                        delete data[media][key];
                    }
                    data && localStorageService.set(ROOTKEY, UE.utils.json2str(data));
                };
            },

            checkLinksForWeixin: function(htmlContent) {
                var result = {
                    TITLE: '正文内容有不合规链接，已为您删除',
                    ISSUCCESS: 'true',
                    REPORTS: [],
                };
                let allLinksReg = /((http|https):\/\/[^"'<]*)"/gi;
                let allLinks = htmlContent.match(allLinksReg);
                if (allLinks && allLinks.length) {
                    let allIframeLinksReg = /<iframe\s*[^>]*src="(http|https):\/\/[^">]*"/gi;
                    let allIframeLinks = htmlContent.match(allIframeLinksReg);
                    var allIframeStr = '';
                    if (allIframeLinks && allIframeLinks.length) {
                        allIframeStr = allIframeLinks.join(',');
                    }
                    allLinks.forEach((item) => {
                        let editCenterImgReg = /([WUP]0|ST)+[123]\d{3}[01][0-9][0-3][0-9]/gi;
                        let url = item.replace('"', '');
                        if (allIframeStr.indexOf(url) === -1 && !editCenterImgReg.test(url) && url.indexOf('mp.weixin.qq.com') === -1) {
                            result.ISSUCCESS = 'false';
                            let report = {
                                TITLE: '',
                                ISSUCCESS: 'false',
                                DETAIL: '正文中的链接' + url + '不合规，已自动删除。',
                                ERRNO: '0',
                                ISNEWFORMAT: '0',
                                URL: url
                            };
                            result.REPORTS.push(report);
                        }
                    });
                }
                return result;
            },

            /**
             * [uploadAttachment 上传附件]
             *
             * @return  {[type]}  [return description]
             */
            uploadAttachment: function() {
                const $defer = $q.defer();
                editingCenterService.uploadAttachment().then((result) => {
                    $defer.resolve(result);
                });
                return $defer.promise;
            },

            /**
             * [insertAttachment 插入附件]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            insertAttachment: function(data) {
                const $defer = $q.defer();
                let dom = '';
                angular.forEach(data, function (value, key){
                    let attachId = trsFileService.getUniqueId(value.FileDesc + value.src + key);
                    let fileIcon = trsFileService.getFileIconImg(value.FileDesc);
                    dom += `<p style="text-align: left;"><a href="${value.src}" attachId="${attachId}"><img src="${fileIcon}" style="width:20px; height:20px; margin-right:5px; vertical-align: baseline;"/><span>${value.FileDesc}</span></a></p>`;
                });
                $defer.resolve(dom);
                return $defer.promise;
            },
            filterXSS,
            
            /**
             * [downLoadOriginImage description] 下载原图 （目前采用canvas的方式，但是如果网络图片地址是https协议会导致跨域问题，暂没法处理）
             * @param   {[object]}  popup  [popup description] dom对象
             * @return  {function}         [return description]
             */
            downLoadOriginImage: function (popup) {
                var img = popup.anchorEl;
                var fileString = $(img).attr('src'),
                    index = fileString.indexOf('='),
                    fileName,
                    params;
                var protocol = fileString.indexOf('https:// ') === 0 ? 'https:// ' : 'http:// ';
                var startIndex = protocol === 'http:// ' ? 7 : 8;
                var hostName = fileString.substring(startIndex);
                var endIndex = hostName.indexOf('/');
                hostName = hostName.substring(0, endIndex);
                if (this.isOutLinkPic(fileString)) {
                    modalDialog.alertType('该图片为外部图片，不允许下载原图', '', 'warning', 'confirm');
                    return;
                }
                if (fileString.indexOf('W0') !== -1 || fileString.indexOf('ST') !== -1 || fileString.indexOf('U0') !== -1) { // 采编图片一般是以W0、ST、U0开头
                    if (index > 0) {
                        fileString = fileString.split('=');
                        fileName = fileString[fileString.length - 1];
                    } else {
                        index = fileString.lastIndexOf('/');
                        fileName = fileString.substring(index + 1, fileString.length);
                    }
                    trsHttpService.httpServerForMR({
                        url: '/wcm/openapi/readimg?FileName=' + fileName,
                        method: 'GET',
                    }, {}, true).then(function (data) {
                        const link = document.createElement('a');
                        const blob = new Blob([data]);
                        // 通过 FileReader 读取这个 blob
                        const reader = new FileReader();
                        reader.onload = e => {
                            const res = e.target.result;
                            // 此处对fileReader读出的结果进行JSON解析
                            // 可能会出现错误，需要进行捕获
                            try {
                                const json = JSON.parse(res);
                                if (json) {
                                    // 解析成功说明后端导出出错，进行导出失败的操作，并直接返回
                                    modalDialog.alertType('下载错误', '', 'error');
                                }
                            } catch (err) {
                                // 该异常为无法将字符串转为json
                                // 说明返回的数据是一个流文件
                                // 不需要处理该异常，只需要捕获即刻
                            }

                            // 如果代码能够执行到这里，说明后端给的是一个流文件，再执行上面导出的代码
                            // do export code
                            link.style.display = 'none';
                            link.href = URL.createObjectURL(blob);
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(link.href);
                        };
                        // 将blob对象以文本的方式读出，读出完成后将会执行 onload 方法
                        reader.readAsText(blob);
                    });
                }
            },

            isOutLinkPic: function(src) {
                let reg = /([WUP]0|ST)+[123]\d{3}[01][0-9][0-3][0-9]/gi;
                return (
                    src !== '' &&
                    src !== 'null' &&
                    src.indexOf('spacer.gif') === -1 &&
                    src.indexOf('./static/') === -1 &&
                    src.indexOf('./images/') === -1 &&
                    src.indexOf('data:image') === -1 &&
                    !reg.test(src)
                );
            },
        };
    },
]);
